/**
 * Pipeline Labs Contact Filters Component
 *
 * Handles email and phone verification filters unique to Pipeline Labs
 * Uses consistent inline styling with Dropdown and Checkbox components
 */

import React from 'react';
import { EMAIL_STATUS_OPTIONS } from '../../../constants/pipelineLabsOptions';

const PipelineLabsContactFilters = ({ filters, setFilters }) => {
  const handleBooleanChange = (field, value) => {
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSelectChange = (field, value) => {
    setFilters(prev => ({
      ...prev,
      [field]: value === '' ? null : value
    }));
  };

  const handleNumberChange = (field, value) => {
    const numValue = parseInt(value, 10);
    setFilters(prev => ({
      ...prev,
      [field]: isNaN(numValue) ? 10000 : Math.min(Math.max(numValue, 1), 50000)
    }));
  };

  return (
    <>
      {/* Email Verification Status - Dropdown */}
      <div style={{ marginBottom: '20px' }}>
        <label style={{
          display: 'block',
          fontSize: '14px',
          fontWeight: '500',
          color: 'var(--color-text-secondary)',
          marginBottom: '8px'
        }}>
          Email Verification Status
        </label>
        <select
          value={filters.emailStatus || ''}
          onChange={(e) => handleSelectChange('emailStatus', e.target.value)}
          style={{
            width: '100%',
            padding: '10px 12px',
            border: '1px solid var(--color-border-strong)',
            borderRadius: '6px',
            fontSize: '14px',
            background: 'white',
            cursor: 'pointer'
          }}
        >
          <option value="">Any (Include All)</option>
          {EMAIL_STATUS_OPTIONS.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <p style={{
          fontSize: '12px',
          color: 'var(--color-text-muted)',
          marginTop: '4px'
        }}>
          Filter by email verification status
        </p>
      </div>

      {/* Has Email - Checkbox */}
      <div style={{ marginBottom: '20px' }}>
        <label style={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          userSelect: 'none'
        }}>
          <input
            type="checkbox"
            id="hasEmail"
            checked={filters.hasEmail || false}
            onChange={(e) => handleBooleanChange('hasEmail', e.target.checked)}
            style={{
              width: '16px',
              height: '16px',
              cursor: 'pointer',
              accentColor: 'var(--color-info-hover)',
              marginRight: '8px'
            }}
          />
          <span style={{
            fontSize: '13px',
            color: 'var(--color-text-secondary)',
            fontWeight: '500'
          }}>
            Require records with email address
          </span>
        </label>
        <p style={{
          fontSize: '12px',
          color: 'var(--color-text-muted)',
          marginTop: '4px',
          marginLeft: '24px'
        }}>
          Only return leads with available email addresses
        </p>
      </div>

      {/* Has Phone - Checkbox */}
      <div style={{ marginBottom: '20px' }}>
        <label style={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          userSelect: 'none'
        }}>
          <input
            type="checkbox"
            id="hasPhone"
            checked={filters.hasPhone || false}
            onChange={(e) => handleBooleanChange('hasPhone', e.target.checked)}
            style={{
              width: '16px',
              height: '16px',
              cursor: 'pointer',
              accentColor: 'var(--color-info-hover)',
              marginRight: '8px'
            }}
          />
          <span style={{
            fontSize: '13px',
            color: 'var(--color-text-secondary)',
            fontWeight: '500'
          }}>
            Require records with phone number
          </span>
        </label>
        <p style={{
          fontSize: '12px',
          color: 'var(--color-text-muted)',
          marginTop: '4px',
          marginLeft: '24px'
        }}>
          Only return leads with available phone numbers
        </p>
      </div>
    </>
  );
};

export default PipelineLabsContactFilters;
